/**
 * Shared Stripe Plan Utilities
 *
 * Client-safe utilities for plan identification and access status checks.
 * Used by both client components and server-side entitlement logic.
 */

/**
 * Checks if an internal plan ID represents a Hobby plan.
 * Uses trailing dash to avoid false matches on hypothetical plans like "stably-hobbymax".
 */
export function isHobbyPlan(internalPlanId: string): boolean {
  return internalPlanId.startsWith('stably-hobby-');
}

/**
 * Determines if a subscription status grants access, considering plan type.
 *
 * Access rules:
 * - `active` / `trialing` -> always grants access (any plan)
 * - `past_due` -> grants access ONLY for non-hobby paid plans (grace period)
 * - All other statuses -> no access
 *
 * This is the shared predicate used by both client and server code.
 */
export function hasAccessGrantingStatus(sub: { status: string; internalPlanId: string }): boolean {
  if (sub.status === 'active' || sub.status === 'trialing') {
    return true;
  }
  if (sub.status === 'past_due') {
    return sub.internalPlanId.length > 0 && !isHobbyPlan(sub.internalPlanId);
  }
  return false;
}
